/**
 * @file index.tsx
 *
 * @fileoverview Shows an image gallery. Takes a list of images (src) and renders them inside a gallery.
 */
import { useRef, useEffect } from "react";
import ReactImageGallery from "react-image-gallery";
import CloseIcon from "@jq-icons/Close";
import FixedElement from "../../../02-atoms/06-layout/08-fixed";
import "react-image-gallery/styles/css/image-gallery.css";
import styles from "./imageGallery.module.scss";

interface ImageSrc {
  caption?: string;
  alt?: string;
  src: string;
}

export interface ImageGalleryProps {
  images: ImageSrc[];
  isGalleryOpen: boolean;
  /**
   * Index of the selected image when the gallery opens.
   */
  startIndex?: number;
  onClose: () => void;
}

export default function ImageGallery({
  images,
  isGalleryOpen,
  startIndex = 0,
  onClose,
}: ImageGalleryProps) {
  const ref = useRef(null);

  useEffect(() => {
    if (isGalleryOpen) {
      (ref as any).current.toggleFullScreen();
      (ref as any)?.current?.slideToIndex(startIndex);
    }
  }, [isGalleryOpen, startIndex]);

  return (
    <div className={styles.imageGallery}>
      {isGalleryOpen ? (
        <ReactImageGallery
          ref={ref}
          showPlayButton={false}
          items={images.map((image) => {
            return { original: image.src, thumbnail: image.src };
          })}
          onScreenChange={(fullscreen) => {
            if (!fullscreen) onClose();
          }}
          renderFullscreenButton={(onClick) => {
            return (
              <FixedElement top="1rem" bottom="inherit">
                <button onClick={onClick}>
                  <CloseIcon height="40" width="40" color="white" title="X" />
                </button>
              </FixedElement>
            );
          }}
        />
      ) : null}
    </div>
  );
}
export { ImageGallery };
